module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.config.IS_USER_ACTIVE) ? _c('div', [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "info text-xs-center",
    attrs: {
      "value": "true"
    }
  }, [_vm._v("\n              Access is currently denied for your account\n              "), _c('br'), _c('br'), _vm._v("\n              Please contact your Community Admin / Integra Back Office to grant access.\n            ")])], 1)], 1)], 1)], 1) : (_vm.config.IS_USER_ACTIVE && _vm.config.ALL_UNITS.findIndex(function (rec) { return rec.rel_status !== 'Linked'; }) >= 0) ? _c('div', [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.config.ALL_UNITS.filter(function (rec) { return rec.rel_status !== 'Linked'; })), function(unit, i) {
    return _c('span', {
      key: i,
      staticClass: "text-xs-center",
      attrs: {
        "color": "info",
        "value": "true"
      }
    }, [(unit.rel_status === 'Pending Approval') ? _c('v-alert', [_vm._v("\n                Your joining request for "), _c('span', {
      staticClass: "subheading yellow--text"
    }, [_vm._v(_vm._s((unit.block_nm ? (unit.block_nm + ' ' + unit.unit_no + ' in ') : '') + _vm.config.COMM_NAME))]), _vm._v(" is yet to be approved by your community admin.\n                "), _c('br'), _c('br'), _vm._v("\n                It may take few hours to process your request and you will be notified as soon as it is done.\n                "), _c('div', [_c('v-btn', {
      staticClass: "mb-0",
      attrs: {
        "flat": "",
        "color": "accent"
      },
      on: {
        "click": _vm.logout
      }
    }, [_vm._v("Logout")])], 1)]) : (unit.rel_status === 'Rejected') ? _c('v-alert', [_vm._v("\n                Your joining request for "), _c('span', {
      staticClass: "yellow--text"
    }, [_vm._v(_vm._s(unit.block_nm + ' ' + unit.unit_no))]), _vm._v(" was rejected with below reason.\n                "), _c('div', {
      staticClass: "text-xs-center white--text mt-2"
    }, [_vm._v("\n                  \"" + _vm._s(unit.rej_reason) + "\"\n                ")]), _vm._v(" "), _c('div', [_c('v-btn', {
      staticClass: "mb-0",
      attrs: {
        "flat": "",
        "color": "accent"
      },
      on: {
        "click": function($event) {
          return _vm.cancelReq(unit)
        }
      }
    }, [_vm._v("Cancel & Sign-up again")])], 1)]) : (unit.rel_status === 'Delinked' && _vm.config.ALL_UNITS.length === 1) ? _c('v-alert', [_vm._v("\n                You are currently delinked from "), _c('span', {
      staticClass: "yellow--text"
    }, [_vm._v(_vm._s((unit.block_nm ? (unit.block_nm + ' ' + unit.unit_no + ' in ') : '') + _vm.config.COMM_NAME))]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                Please contact your Community Admin / Integra Back Office if you did not expect to see this message.\n                "), _c('div', [_c('v-btn', {
      staticClass: "mb-0",
      attrs: {
        "flat": "",
        "color": "accent"
      },
      on: {
        "click": _vm.logout
      }
    }, [_vm._v("Logout")])], 1)]) : _vm._e()], 1)
  }), 0)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.config.IS_USER_ACTIVE && _vm.config.UNITS.findIndex(function (rec) { return rec.rel_status === 'Linked'; }) >= 0) ? _c('div', [_c('v-container', {
    staticClass: "pa-2",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.joinReq.length) ? _c('v-flex', {
    staticClass: "pb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": {
        path: (_vm.config.IS_ADMIN ? '/users' : '/profile/join')
      }
    }
  }, [_c('v-card-title', {
    staticClass: "pa-2 subheading primary lighten-2 white--text"
  }, [_vm._v("\n                Joining Requests\n              ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.joinReq.length + ' request' + (_vm.joinReq.length > 1 ? 's' : '')) + " pending for your review!")])])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isMobAdminUser) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mb-1"
  }, [_c('v-card-title', {
    staticClass: "pa-2 subheading primary lighten-2 white--text"
  }, [_vm._v("\n            Welcome to Integra Admin!\n          ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-1"
  }, [_vm._v("\n            Do you know, you can access this Integra App in your mobile phone as well?\n            "), _c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_vm._v("\n                Android\n                "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://play.google.com/store/apps/details?id=in.smartility.app&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
    }
  }, [_c('img', {
    attrs: {
      "width": "150",
      "alt": "Get it on Google Play",
      "src": "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
    }
  })])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_vm._v("\n                iPhone\n                "), _c('div', {
    staticClass: "pa-2"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.dlgHowToiPhone = true
      }
    }
  }, [_c('img', {
    attrs: {
      "alt": "Install web app",
      "width": "140",
      "src": _vm.config.STATIC_FILES_DIR + '/img/others/pwa_app.png'
    }
  })])])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tasks) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 text-xs-center warning",
    attrs: {
      "to": {
        path: '/task'
      }
    }
  }, [_c('v-card-title', {
    staticClass: "px-2 pt-1 pb-0 subheading black--text"
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "large": ""
    }
  }, [_vm._v("group_work")]), _vm._v("Task\n          ")], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-2 pt-0 pb-1"
  }, [_vm._v("\n            " + _vm._s(_vm.tasks.tot_task) + "\n            "), (_vm.tasks.past_due) ? _c('v-chip', {
    staticClass: "error white--text caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.tasks.past_due + ' past due'))]) : _vm._e(), _vm._v(" "), (_vm.tasks.due_today) ? _c('v-chip', {
    staticClass: "warning white--text caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.tasks.due_today + ' due today'))]) : _vm._e(), _vm._v(" "), (_vm.tasks.pend_appr) ? _c('v-chip', {
    staticClass: "white caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.tasks.pend_appr + ' for your approval'))]) : _vm._e()], 1)], 1)], 1) : (_vm.tasks) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 text-xs-center primary lighten-2 white--text",
    attrs: {
      "to": {
        path: '/task'
      }
    }
  }, [_c('v-card-title', {
    staticClass: "px-2 pt-1 pb-0 subheading black--text"
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "large": ""
    }
  }, [_vm._v("group_work")]), _vm._v("Task\n          ")], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_vm._v("\n            " + _vm._s(_vm.tasks ? _vm.tasks.tot_task : 0) + "\n            "), (_vm.tasks && _vm.tasks.past_due) ? _c('v-chip', {
    staticClass: "error white--text caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.tasks.past_due + ' past due'))]) : _vm._e(), _vm._v(" "), (_vm.tasks && _vm.tasks.due_today) ? _c('v-chip', {
    staticClass: "warning white--text caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.tasks.due_today + ' due today'))]) : _vm._e(), _vm._v(" "), (_vm.tasks && _vm.tasks.pend_appr) ? _c('v-chip', {
    staticClass: "white caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.tasks.pend_appr + ' for your approval'))]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "display-1 primary lighten-2"
  }, [_c('v-card-title', {
    staticClass: "px-2 pt-1 pb-0 subheading black--text"
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "large": ""
    }
  }, [_vm._v("engineering")]), _vm._v("Facility Management\n            "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    class: 'caption ml-0 mr-1 black--text ' + (_vm.statDay === 'yesterday' ? 'primary lighten-5' : 'primary lighten-3'),
    attrs: {
      "small": "",
      "disabled": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadStatsForStaffDashboard('yesterday')
      }
    }
  }, [_vm._v("yesterday")]), _vm._v(" "), _c('v-chip', {
    class: 'caption ma-0 black--text ' + (_vm.statDay === 'today' ? 'primary lighten-5' : 'primary lighten-3'),
    attrs: {
      "small": "",
      "disabled": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadStatsForStaffDashboard('today')
      }
    }
  }, [_vm._v("today")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "to": {
        path: '/attendance'
      }
    }
  }, [_c('v-card-title', {
    staticClass: "pt-0 pb-0 pl-2 pr-0 subheading primary darken-1 warning--text"
  }, [_c('v-icon', {
    staticClass: "pr-2 warning--text"
  }, [_vm._v("camera_front")]), _vm._v("Attendance\n                    "), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "to": {
        path: '/attendance'
      }
    }
  }, [_c('v-card-text', {
    staticClass: "pt-1 pb-2 px-2 subheading primary darken-1 warning--text",
    staticStyle: {
      "height": "85px"
    }
  }, [_c('div', {
    staticClass: "text-xs-center white--text",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n                      " + _vm._s((_vm.attend.percent || 0) + '%')), _c('br'), _vm._v(" "), (_vm.attend.tot_pend) ? _c('v-chip', {
    staticClass: "red white--text",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.attend.tot_pend + ' pending'))]) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pt-0 pb-0 pl-2 pr-0 subheading primary darken-1 warning--text"
  }, [_c('v-icon', {
    staticClass: "pr-2 warning--text"
  }, [_vm._v("today")]), _vm._v("Daily Update\n                    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showDateList = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("open_in_new")])], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "to": {
        path: '/dailyupdate'
      }
    }
  }, [_c('v-card-text', {
    staticClass: "pt-1 pb-2 px-2 subheading primary darken-1 warning--text",
    staticStyle: {
      "height": "85px"
    }
  }, [_c('div', {
    staticClass: "text-xs-center white--text",
    staticStyle: {
      "font-size": "22px"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.dailyUpdate.c_date ? (_vm.dailyUpdate.is_sub_app || _vm.dailyUpdate.is_app ? 'Done' : 'Draft') : 'Pending') + " "), _c('br'), _vm._v(" "), (_vm.dailyUpdate.tot_pend) ? _c('v-chip', {
    staticClass: "red white--text caption",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.dailyUpdate.tot_pend + ' days pending'))]) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "to": {
        path: '/inventory'
      }
    }
  }, [_c('v-card-title', {
    staticClass: "pt-0 pb-0 pl-2 pr-0 subheading primary darken-1 warning--text"
  }, [_c('v-icon', {
    staticClass: "pr-2 warning--text"
  }, [_vm._v("category")]), _vm._v("Assets\n                    "), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "to": {
        path: '/inventory'
      }
    }
  }, [_c('v-card-text', {
    staticClass: "pt-1 pb-2 px-2 subheading primary darken-1 warning--text",
    staticStyle: {
      "height": "85px"
    }
  }, [_c('div', {
    staticClass: "text-xs-center white--text",
    staticStyle: {
      "font-size": "26px"
    }
  }, [(_vm.assets.amc_past_due) ? _c('span', [_vm._v(_vm._s(_vm.assets.amc_past_due) + " "), _c('span', {
    staticClass: "red--text body-1"
  }, [_vm._v("AMC past due")]), _c('br')]) : _vm._e(), _vm._v("\n                      " + _vm._s(_vm.assets.amc_due_soon) + " "), _c('span', {
    class: 'body-1 ' + (_vm.assets.amc_due_soon ? 'red--text' : '')
  }, [_vm._v("AMC due soon")]), _vm._v(" "), (_vm.assets.tot_outside) ? _c('v-chip', {
    staticClass: "white caption",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.assets.tot_outside + ' out for service'))]) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "to": {
        path: '/incidents'
      }
    }
  }, [_c('v-card-title', {
    staticClass: "pt-0 pb-0 pl-2 pr-0 subheading primary darken-1 warning--text"
  }, [_c('v-icon', {
    staticClass: "pr-2 warning--text"
  }, [_vm._v("report_problem")]), _vm._v("Incidents\n                    "), _c('v-spacer')], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "to": {
        path: '/incidents'
      }
    }
  }, [_c('v-card-text', {
    staticClass: "pt-1 pb-2 px-2 subheading primary darken-1 warning--text",
    staticStyle: {
      "height": "85px"
    }
  }, [_c('div', {
    staticClass: "text-xs-center white--text",
    staticStyle: {
      "font-size": "26px"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.incidents.length || 0) + "\n                    ")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.dlgHowToiPhone),
      callback: function($$v) {
        _vm.dlgHowToiPhone = $$v
      },
      expression: "dlgHowToiPhone"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-1"
  }, [_vm._v("\n          How to install in iPhone?\n        ")]), _vm._v(" "), _c('v-card-text', [_c('ul', {
    staticClass: "mt-2"
  }, [_c('li', [_vm._v("\n              Open your safari browser\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              Go to "), _c('a', {
    attrs: {
      "href": "https://app.integrafms.com",
      "target": "_blank"
    }
  }, [_vm._v("https://app.integrafms.com")])]), _vm._v(" "), _c('li', [_vm._v("\n              Tap on share icon at the bottom of your browser window\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n              Tap on \"Add to Home Screen\" to install the app\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    attrs: {
      "width": "85%",
      "src": _vm.config.STATIC_FILES_DIR + '/img/others/pwa_install.png'
    }
  })])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgHowToiPhone = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showDateList),
      callback: function($$v) {
        _vm.showDateList = $$v
      },
      expression: "showDateList"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-1 title grey lighten-4"
  }, [_vm._v("\n      List Of FM Daily Update Pending dates\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDateList = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.dateHeader,
      "items": _vm.dailyUpdate.dateList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.selected_date)))])])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('v-container', [_c('v-layout', [_c('v-flex', {
    staticClass: "text-xs-center mt-4",
    staticStyle: {
      "opacity": "0.25"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    attrs: {
      "height": "100",
      "width": "250",
      "src": _vm.config.STATIC_FILES_DIR + '/img/logo/integra_logo.png'
    }
  })])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f520327c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 924
// module chunks = 29